export const organizationConstructionMaterialPriceChangeConstants = {
	Create: {
		FAILURE : 'CREATE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'CREATE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'CREATE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	Delete: {
		FAILURE : 'DELETE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'DELETE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'DELETE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	GetPaged: {
		FAILURE : 'GET_PAGED_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_PAGED_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_PAGED_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	GetOrganizations: {
		FAILURE : 'GET_ORGANIZATIONS_IN_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_ORGANIZATIONS_IN_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_ORGANIZATIONS_IN_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	Update: {
		FAILURE : 'UPDATE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'UPDATE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'UPDATE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	GetPricesFile: {
		FAILURE : 'GET_PRICES_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_PRICES_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_PRICES_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	GetLastPricePaged: {
		FAILURE : 'GET_PAGED_LAST_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_PAGED_LAST_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_PAGED_LAST_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	GetExampleFile: {
		FAILURE : 'GET_EXAMPLE_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_EXAMPLE_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_EXAMPLE_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	GetByFile: {
		FAILURE : 'GET_BY_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_FAILURE',
		REQUEST : 'GET_BY_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_REQUEST',
		SUCCESS : 'GET_BY_FILE_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_SUCCESS'
	},
	CLEAR: 'GET_ORGANIZATION_CONSTRUCTION_MATERIAL_PRICE_CHANGE_CLEAR'
}